import { Spacer, Tag, TextCapitalized } from "@qivia/ui";
import { SidePanelDS } from "@qivia/ui";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { selectCompany } from "../../homeSlice";
import {
  loadAllCompaniesAsync,
  selectAllCompanies,
  selectAllCompaniesStatus,
} from "../../companies/companiesSlice";
import { ManagerRole } from "../usersAPI";
import "../../../../i18n/i18n";

export const SidePanelUserEntities = (props: {
  managerRole: ManagerRole;
  companiesAccess: string[] | null | undefined;
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectCompany);
  const companies = useAppSelector(selectAllCompanies);
  const loadCompaniesStatus = useAppSelector(selectAllCompaniesStatus);

  useEffect(() => {
    if (company && loadCompaniesStatus === "idle") {
      void dispatch(loadAllCompaniesAsync());
    }
  }, [company, dispatch, loadCompaniesStatus]);

  if (props.managerRole !== "ADMIN" && props.managerRole !== "USER") {
    return null;
  }

  if (props.companiesAccess == null) {
    return null;
  }

  return (
    <SidePanelDS.Section horizontalSpacing={1.5} verticalSpacing={1.5}>
      <TextCapitalized>
        <StyledSectionTitle>
          {t("users.management.sidePanel.entities.title")}
        </StyledSectionTitle>
      </TextCapitalized>
      <Spacer y={1} />
      <StyledChipRow>
        {props.companiesAccess.map((uuid) => {
          const companyName = companies.find((c) => c.uuid === uuid)?.name;
          if (!companyName) {
            return;
          }
          return (
            <Tag
              key={uuid}
              text={companyName}
              textColor={colors["colors/text/darkGrey"]}
              backgroundColor={
                colors["colors/surfaces/background/background_level0"]
              }
              borderColor={colors["colors/borders/cells/cells"]}
            />
          );
        })}
      </StyledChipRow>
    </SidePanelDS.Section>
  );
};

const StyledSectionTitle = styled.div`
  ${typographies["Body/L"]}
  color: ${colors["colors/text/darkGrey"]};
`;
const StyledChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;
